<template>
  <div>
    <Podium :users="podium" class="tw-mt-8" @show="show" />
    <v-list class="mt-6" three-line>
      <v-card v-for="(user, position) in users" :key="user.id" class="my-4" flat hover @click="show(user.id)">
        <v-card-text>
          <v-list-item>
            <v-badge color="black" left overlap>
              <template #badge> #{{ position + 4 }}</template>
              <template #default>
                <v-list-item-avatar size="58">
                  <img
                    :alt="user.user_name"
                    :src="user.avatar || 'https://cdn.securating.io/public/storage/shared/common/anonymous_avatar1.png'"
                  />
                </v-list-item-avatar>
              </template>
            </v-badge>

            <v-list-item-content>
              <v-list-item-title>
                <a v-if="getName(user) !== ''" :title="getUserName(user)" class="sr-mention" v-html="getName(user)"></a>
                <a
                  v-if="getName(user) === '' && getUserName(user) !== ''"
                  class="sr-mention"
                  v-text="'@' + getUserName(user)"
                ></a>
                <a
                  v-if="getName(user) === '' && getUserName(user) === ''"
                  class="sr-mention"
                  v-text="'@' + getOrigin(user)"
                ></a>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span class="font-weight-medium">{{ $t("dashboard.ranking.publications") }} : </span>
                {{ user.publication_counter }}
                <span class="ml-4 font-weight-medium">{{ $t("dashboard.ranking.created") }} : </span>
                {{ user.created_at | moment("from") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>
        <hr />
      </v-card>
    </v-list>
  </div>
</template>

<script>
import Podium from "./Podium"
import { Types as TypesLoading } from "@/store/modules/loading"

export default {
  name: "RankingList",
  components: {
    Podium,
  },
  data: () => ({
    users: [],
    podium: [],
  }),
  mounted() {
    this.getUsers()
  },
  methods: {
    getUsers() {
      this.$store.commit(TypesLoading.mutations.LOADING_YES)
      this.$axios
        .get("office/me/users/ranking")
        .then(response => {
          this.users = response.data
          this.podium = this.users.splice(0, 3)
        })
        .finally(() => this.$store.commit(TypesLoading.mutations.LOADING_NO))
    },
    // Show the selected user
    show(id) {
      let user

      if (this.podium.some(user => user.id === id)) {
        user = Object.assign(...this.podium.filter(user => user.id === id))
      }

      if (this.users.some(user => user.id === id)) {
        user = Object.assign(...this.users.filter(user => user.id === id))
      }

      this.$emit("show", user)
    },
    getUserName(user) {
      const semicolonPos = user.user_name.indexOf(":")
      if (semicolonPos > 0) {
        return ""
      } else {
        return `${user.user_name}`
      }
    },
    getName(user) {
      let name = ""
      if (user.first_name) name = name + " " + user.first_name
      if (user.last_name) name = name + " " + user.last_name
      return name.trim()
    },
    displayOrigin(user) {
      return this.$t("origin.source") + this.getOrigin(user)
    },
    getOrigin(user) {
      const securating = "Securating"
      const semicolonPos = user.user_name.indexOf(":")
      if (semicolonPos > 0) {
        const prefix = user.user_name.substr(0, semicolonPos)

        switch (prefix) {
          case "anonymous":
            return securating
          default:
            return `${this.$t("origin." + prefix)}`
        }
      } else {
        return securating
      }
    },
  },
}
</script>
